// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "5ffe1889" + "." + "99fa3f6ac45cc742" + ".js";
};